
import { CartaCreditoFinanceiroGerada } from './carta-credito-financeiro-gerada.model';
import { EmpresaVO } from './empresa-vo.model';
import { ValorCartaCreditoAnualVO } from './valor-carta-credito-anual-vo.model';
import { AcumuladoVO } from './acumulado-vo.model';
import { ValorCartaCreditoFinanceiro } from './valor-carta-credito.model';

export class CartaGeradaAnualVO {

  empresa: EmpresaVO;
  cartaGerada: CartaCreditoFinanceiroGerada;
  sudanSudene: ValorCartaCreditoAnualVO;
  demaisRegioes: ValorCartaCreditoAnualVO;
  total: ValorCartaCreditoAnualVO;
  relacaoPampd: ValorCartaCreditoFinanceiro;
  acumulado: AcumuladoVO;
  
}
